$(document).ready(function() { 
	//if(!document.getElementById('searchResultsFilter')) return false;

	var s = {
		supportWrapper: document.querySelector('.search-result-support'),
		els: {
			results: document.querySelectorAll('.sorting-result strong'),
			subTabSelect: document.getElementById('MenuSelect'),
			//resultsList: document.getElementById('searchResultsList'),
			resultsList: (document.getElementById('searchResultsList')) ? document.getElementById('searchResultsList') : document.querySelectorAll('.result-resources-conts'),
			resources: {
				modal: document.getElementById('model_results_resources_layer'),
				modalContents: document.getElementById('resources_modal_contents')
			} 
		}, 
		init: function(){
			var _this = this;
			if(document.getElementById('searchResultsList')) _this.filter.init();
			_this.addEvent();
		},
		filter: {
			els: {
				form: document.getElementById('searchResultsFilter'),
				sort: document.getElementById('sortBy'),
				target: document.getElementById('searchResultsList')
			},
			category: {
				data: typeof productCategory != 'undefined' ? productCategory:null,
				els: {
					major: document.getElementById('majorCategory'),
					sub: document.getElementById('subCategory')
				},
				createOptions: function(data, el){
					var categoryData = data,
						html = '',
						needSub = false,
						needMajor = false;

					for (var i = 0; i < categoryData.length; i++) {
						var currentCategory = categoryData[i],
							text = '',
							selected = '';

						// if category has flag data, filtering flag == "N" option
						if(!currentCategory.flag || currentCategory.flag.toUpperCase() != "N") {
							if(html == '') {
								// first-option
								if(currentCategory.categoryNumber != '0') {
									html += '<option value="0">'+productCategory[0].categoryName+'</option>'; // all products
								}else {
									if(currentCategory.itemLength) el.setAttribute('data-length', currentCategory.itemLength);
									el.setAttribute('data-name', currentCategory.categoryName);
									selected = 'selected';
								}
							}
							if(currentCategory.selected) {
								selected = 'selected';
								needSub = true;
								needMajor = currentCategory.categoryNumber;
							}
							if(!currentCategory.itemLength) {
								text = currentCategory.categoryName;
								html += '<option value="'+currentCategory.categoryNumber+'" '+selected+'>'+text+'</option>';
							} else {
								text = currentCategory.categoryName+" ("+currentCategory.itemLength+")";
								html += '<option value="'+currentCategory.categoryNumber+'" '+selected+' data-length="'+currentCategory.itemLength+'" data-name="'+currentCategory.categoryName+'">'+text+'</option>';
							}
							// currentCategory
						}
					}
					$(el).html(html).removeAttr('disabled').trigger('chosen:updated');

					if(needSub) {
						// console.log('sub');
						var subList = this.returnMatchCategory(needMajor);
						if(subList) this.createOptions(subList, this.els.sub);

						var _this = s;
						var param = $(_this.filter.category.els.major).serialize().replace(/\%26/g, '_and_') + "&" + $(_this.filter.category.els.sub).serialize().replace(/\%26/g, '_and_');
						//console.log(param);
						$(_this.supportWrapper).find('.menu-select .btn-tab, .menu-select select').attr('data-param', param);
					}
				},
				returnMatchCategory: function(categoryNumber){
					var _cate = this,
						categoryList = _cate.data;
					for (var i = 0; i < categoryList.length; i++) {
						var list = categoryList[i];
						if(list.categoryNumber == categoryNumber) {
							return list.subCategory;
						}
					}
				},
				init: function(){
					var _this = s,
						_cate = this;
					_cate.createOptions(_cate.data, _cate.els.major);
					if($(_cate.els.sub).find('option').length==0) {
						$(_cate.els.sub).html('<option>'+$(_cate.els.sub).attr('data-placeholder')+'</option>').removeAttr('data-length').trigger('chosen:updated');
					}
					_cate.addEvent();
				},
				addEvent: function(){
					var _this = s,
						_cate = this;

					$(_cate.els.major).on({
						change:function(e){
							var cateNumber = e.currentTarget.value,
								name = e.currentTarget.getAttribute('name'),
								subcategoryList = _cate.returnMatchCategory(cateNumber),
								selected = $(e.currentTarget).find('option:selected')[0];
							
							if(subcategoryList) {
								_cate.createOptions(subcategoryList, _cate.els.sub);
							}else {
								_cate.els.sub.setAttribute('disabled','disabled');
								$(_cate.els.sub).html('<option>'+$(_cate.els.sub).attr('data-placeholder')+'</option>').removeAttr('data-length').trigger('chosen:updated');
							}

							e.currentTarget.setAttribute('data-length', selected.getAttribute('data-length'));
							_cate.els.sub.removeAttribute('data-length');
							_this.filter.els.form[name].value = cateNumber;
							_this.filter.els.form[_cate.els.sub.getAttribute('name')].value = '';
						}
					});
					$(_cate.els.sub).on({
						change: function(e){
							var cateNumber = e.currentTarget.value,
								name = e.currentTarget.getAttribute('name'),
								selected = $(e.currentTarget).find('option:selected')[0];

							e.currentTarget.setAttribute('data-length', selected.getAttribute('data-length'));
							_this.filter.els.form[name].value = cateNumber;
						}
					});
				}
			},
			init: function(){
				var _this = s,
					_filter = this;
				if(_filter.category.data) _filter.category.init();
				
				_filter.addEvent();
			},
			addEvent: function(){
				var _this = s,
					_filter = this;

				$(_filter.els.sort).on({
					change: function(e){
						var sortType = e.currentTarget.value,
							name = e.currentTarget.getAttribute('name');
						_filter.els.form[name].value = sortType;
						_filter.els.form.nowPage.value = 1;
						$(_filter.els.form).trigger('triggered');
					},
					reset: function(e){
						var name = e.currentTarget.getAttribute('name');
						e.currentTarget.value = '';
						_filter.els.form[name].value = '';
						_filter.els.form.nowPage.value = 1;
						$(e.currentTarget).trigger('chosen:updated');
					}
				});
				$(_filter.els.form).on({
					// category filter submit;
					submit: function(e){
						e.preventDefault();
						var length = _this.filter.category.els.sub.getAttribute('data-length');
						// $(_filter.els.sort).trigger('reset');
						if(_filter.els.sort) {
							_filter.els.sort.options[0].selected = true;
							$(_filter.els.sort).trigger('chosen:updated');
						}
						if(_filter.els.form.nowPage){
							_filter.els.form.nowPage.value = 1;
						}
						$(e.currentTarget).trigger('triggered');

						length = (length && length != "null") ? length : _this.filter.category.els.major.getAttribute('data-length');

						if($(s.supportWrapper).length==0) {
							for (var i = 0; i < _this.els.results.length; i++) {
								$(_this.els.results[i]).text(length);
							}
						}

						var param = $(_this.filter.category.els.major).serialize().replace(/\%26/g, '_and_') + "&" + $(_this.filter.category.els.sub).serialize().replace(/\%26/g, '_and_');
						$(_this.supportWrapper).find('.menu-select .btn-tab, .menu-select select').attr('data-param', param);
						
						//solution-banner
						if($('.solution-banner').length>0) {
							var banner = _this.supportWrapper.querySelector('a.btn-primary');
							if(_this.filter.category.els.sub.value != '') {
								var currentSupCate = _this.filter.category.els.major.options[_this.filter.category.els.major.selectedIndex].getAttribute('data-name');
								var currentCate = _this.filter.category.els.sub.options[_this.filter.category.els.sub.selectedIndex].getAttribute('data-name');
								var bannerParam = 'superCategoryName='+(currentSupCate == null ? '' : currentSupCate.replace(/\&/g, '_and_'))+'&categoryName='+(currentCate == null ? '' : currentCate.replace(/\&/g, '_and_'));
								var bannerLink = _this.supportWrapper.querySelector('a.btn-primary').getAttribute('href');
								if(bannerLink.indexOf('?') > 0) {
									bannerLink = bannerLink.split('?')[0];
								}
								bannerLink = bannerLink+"?"+bannerParam;
								banner.href = bannerLink;
								$(banner).closest('.solution-banner').addClass('active');
							}else {
								$(banner).closest('.solution-banner').removeClass('active');
							}
						}
					},
					// page change;
					triggered: function(e){
						var isExpander = $(_this.els.resultsList).data('focus') == true;

						var cur = e.currentTarget,
							url = cur.action,
							param = xssfilter($(cur).serialize()),
							target = _filter.els.target;

						ajax.call(url, param, 'html', function(data){
							if(data) {
								var $data = $(xssfilter(data, true));
								
								$data.find('.item, .resources-wrap, .discover').eq(0).addClass('first-item');

								//data = $data.get(0).outerHTML;
								data = $data;

								if(isExpander) {
									var expanderBtn = $(data).find('.expander').html();
									data = $(data).find('.unit-list').html();
									$(target).find('.unit-list').append(data);
									$(target).find('.expander').append(expanderBtn);
									bindImgError();
								}else {
									if(document.querySelector('.video-tutorials-result-wrap') && document.querySelector('.help-library-result-wrap')){
										var videoTutorial = $data.find('.video-tutorials-result').html(),
											helpLibrary = $data.find('.help-library-result').html();

										$(document.querySelector('.video-tutorials-result-wrap')).html(videoTutorial);
										$(document.querySelector('.help-library-result-wrap')).html(helpLibrary);

										$data.find('.video-tutorials-result').remove();
										$data.find('.help-library-result').remove();
										data = $data.get(0).outerHTML;
									}

									$(target).html(data);
									bindImgError();
									$('html, body').animate({
										scrollTop: $(cur).offset().top
									});
								}

								var $focusItem = $(target).find(".first-item");
								if(isExpander) $($focusItem).find("a").eq(0).focus();
								$($focusItem).removeClass("first-item");

								if($(s.supportWrapper).length>0) {
									setTimeout(function() {
										if($('#searchResultsList .list-wrap:last-child').attr('data-result-count')) {
											var thisLen = $('#searchResultsList .list-wrap:last-child').attr('data-result-count');
											for (var i = 0; i < _this.els.results.length; i++) {
												$(_this.els.results[i]).text(thisLen);
											}
										} else {
											if($('#searchResultsList .no-content').length>0) {
												for (var i = 0; i < _this.els.results.length; i++) {
													$(_this.els.results[i]).text('0');
												}
											}
										}
									}, 100);
								}

							}
						});
					}
				});
			}
		},
		addEvent: function(){
			var _this = this;
			$(_this.supportWrapper).find('.menu-select .btn-tab').off('click');
			$(_this.supportWrapper).on({
				"click": function(e){
					e.preventDefault();
					var url, paramData = e.currentTarget.getAttribute('data-param');
					url = e.currentTarget.getAttribute('href');
					var and = url.indexOf('?') > -1 ? "&" : "?";
					url = paramData ? url + and + paramData : url;
					window.location.href = url;
				}
			}, '.btn-tab');
			$(_this.supportWrapper).find('.menu-select').on({
				"change": function(e){
					e.preventDefault();
					var url, paramData = e.currentTarget.getAttribute('data-param');
					url = e.currentTarget.value;
					var and = url.indexOf('?') > -1 ? "&" : "?";
					url = paramData ? url + and + paramData : url;
					window.location.href = url;
				}
			}, 'select');
			$('.search-result-resources .menu-select select').on('change', function(e) {
				e.preventDefault();
				var url = e.currentTarget.value;
				window.location.href = url;
			});
			$(_this.els.resultsList).on({
				click: function(e){
					e.preventDefault();
					var curTarget = e.currentTarget,
						appendTarget = _this.els.resources.modalContents,
						modal = _this.els.resources.modal,
						modalContents= null;
					$(curTarget).siblings('.modal-contents-template').find('script').remove();

					modalContents = $(curTarget).siblings('.modal-contents-template').html();
					$(appendTarget).html(modalContents);
					$(modal).modal('show');
				}
			}, '.resources-modal-anchor');

			// page & load more button script
			$(_this.els.resultsList).on({
				click: function(e){
					e.preventDefault();
					var page = e.currentTarget.value,
						targetForm = s.filter.els.form,
						_del = e.delegateTarget;
					targetForm.nowPage.value = e.currentTarget.value;
					if($(e.currentTarget).closest('.expander')[0]) {
						$(_del).data('focus', true);
						$(e.currentTarget).remove();
					}else {
						$(_del).data('focus', false);
					}
					$(targetForm).trigger('triggered');
				}
			}, '.pagination button, .expander button');

		}
	};
	s.init();

	// for adobe tagging
	$adobeObj = $('a.key-promotion-item, .list-box li .item a.visual, .list-box li .item .products-info .model-name a, .promotions-list .button a.btn, .result-discover-list .discover a, .list-box .item > a, .item-list .item a, a.resources-modal-anchor, .articles .item-list .item a, .products-box .item .left-info a.visual, .products-box .item .products-info .model-name a');
	$adobeObj.on('click', function() {
		adobeTrackEvent('search-result', {search_keyword : $('.search-area-box form .search-area .search-input input[type=text]').val(), page_event : {search_result_click : true}});
	});

	// for search statistics api 
	var searchStatsAPI = {
		url: $('.search-wrap .search-area-box').data('search-api'),
		search: $('.search-wrap .search-area-box form .search-input input[name=search]').val(),
		init: function() {
			// key promotions
			$('body').on('click.searchapi', '.key-promotion a.key-promotion-item', function() {
				// view all > key promotions
				var meta1 = $(this).find('.item-textbox-head').text();
				if(meta1) searchStatsAPI.requestAjax('keyword', $(this).attr('href'), meta1, null, null);
			});
			// single products
			$('body').on('click.searchapi', '.products-box .item .left-info a.visual, .products-box .item .left-info + .products-info .model-name a', function() {
				var meta1 = $(this).closest('.item').find('.products-info .model-name').text(),
					meta2 = $(this).closest('.item').find('.products-info .sku').text(),
					meta3 = $(this).closest('.item').find('a.visual').data('model-id');
				if($(this).closest('.products-box').hasClass('b2b')) {
					if(meta1 && meta2 && meta3) searchStatsAPI.requestAjax('product_b2b', $(this).attr('href'), meta1, meta2, meta3);
				} else {
					if(meta1 && meta2 && meta3) searchStatsAPI.requestAjax('product_b2c', $(this).attr('href'), meta1, meta2, meta3);
				}
			});
			// consumer products
			$('body').on('click.searchapi', '.product-list-box .list-box li .item a.visual, .product-list-box .list-box li .item .model-name a', function() {
				var meta1 = $(this).closest('.item').find('.products-info .model-name').text(),
					meta2 = $(this).closest('.item').find('.products-info .sku').text(),
					meta3 = $(this).closest('.item').find('a.visual').data('model-id');
				if(meta1 && meta2 && meta3) searchStatsAPI.requestAjax('product_b2c', $(this).attr('href'), meta1, meta2, meta3);
			});
			// business products
			$('body').on('click.searchapi', '.business-product-list .list-box li .item a.visual, .business-product-list .list-box li .item .model-name a', function() {
				var meta1 = $(this).closest('.item').find('.products-info .model-name').text(),
					meta2 = $(this).closest('.item').find('.products-info .sku').text(),
					meta3 = $(this).closest('.item').find('a.visual').data('model-id');
				if(meta1 && meta2 && meta3) searchStatsAPI.requestAjax('product_b2b', $(this).attr('href'), meta1, meta2, meta3);
			});
			// promotions
			$('body').on('click.searchapi', '.promotions-list .promotion-info .button a', function() {
				// view all > promotion list
				// promotions > list
				var meta1 = $(this).closest('.item').find('.promotion-name').text();
				if(meta1) searchStatsAPI.requestAjax('promotion', $(this).attr('href'), meta1, null, null);
			});
			// discover
			$('body').on('click.searchapi', '.discover-wrap .discover .img a, .discover-wrap .discover .btn-text-area a', function() {
				// view all > disover list
				// discover > list
				var meta1 = $(this).closest('.discover').find('.discover-title').text();
				if(meta1) searchStatsAPI.requestAjax('discover', $(this).attr('href'), meta1, null, null);
			});
			// support
			$('body').on('click.searchapi', '.product-support-list .list-box li .item a.visual, .product-support-list .list-box li .item .model-name a, .product-support-list .list-box li .item .friendly-name a', function() {
				// view all > support > product list 
				// support > list
				var meta1 = $(this).closest('.item').find('.products-info .model-name').text(),
					meta2 = $(this).closest('.item').find('.products-info .friendly-name').text();
				if(meta1) searchStatsAPI.requestAjax('product_support', $(this).attr('href'), meta1, meta2, null);
			});
			$('body').on('click.searchapi', '.search-result-support .item-list .item a', function() {
				// view all > support > non-product
				// support > list
				var meta1 = $(this).closest('.item').find('.summary .title').text(),
					meta2 = $(this).closest('.item').find('.summary .category span').eq(0).text(),
					meta3 = $(this).closest('.item').find('.summary .category span').eq(1).text();
				if($(this).closest('.item-list').hasClass('video')) {
					if(meta1) searchStatsAPI.requestAjax('video', $(this).attr('href'), meta1, meta2, meta3);
				} else {
					if(meta1) searchStatsAPI.requestAjax('helplibrary', $(this).attr('href'), meta1, meta2, meta3);
				}
			});
			// resources
			$('body').on('click.searchapi', '.result-resources-list .resources-wrap .resources a', function() {
				// view all > resources list
				// resources > list
				var meta1 = $(this).closest('.resources').find('.resources-text').text(),
					meta2 = $(this).closest('.resources').find('.resources-title').text(),
					href = $(this).attr('href');
				if($(this).hasClass('resources-modal-anchor')) href='';
				if(meta1) searchStatsAPI.requestAjax('resources', href, meta1, meta2, null);
			});
			// articles
			$('body').on('click.searchapi', '.articles .item-list .item a', function() {
				// view all > articles list
				// articels > list
				var meta1 = $(this).closest('.item').find('.summary .title').text(),
					meta2 = $(this).closest('.item').find('.summary .name').text(),
					href = $(this).attr('href');
				if($(this).hasClass('resources-modal-anchor')) href='';
				if(meta1) searchStatsAPI.requestAjax('articles', href, meta1, meta2, null);
			});
		},
		requestAjax: function(index, linkUrl, meta1, meta2, meta3) {
			var url = this.url;
			var data = {};
			data.search = searchStatsAPI.search;
			data.index = index;
			data.linkUrl = linkUrl;
			if(meta1) data.meta1 = meta1;
			if(meta2) data.meta2 = meta2;
			if(meta3) data.meta3 = meta3;
			console.log('%cSearch Stats API >> search:'+searchStatsAPI.search+', index:'+index+', linkUrl:'+linkUrl+', meta1:'+meta1+', meta2:'+meta2+', meta3:'+meta3, 'color:green;');
			$.ajax({
				url: url,
				type: 'get',
				data: data
			});
		}
	};
	searchStatsAPI.init();
});
// resources와 articles 에서 클릭시 modal이 뜨는 경우. url은?